import { render, staticRenderFns } from "./registersList.vue?vue&type=template&id=b38757bc&scoped=true"
import script from "./registersList.vue?vue&type=script&lang=js"
export * from "./registersList.vue?vue&type=script&lang=js"
import style0 from "./registersList.vue?vue&type=style&index=0&id=b38757bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38757bc",
  null
  
)

export default component.exports